import { Component, OnInit } from '@angular/core';
import { Experience, WMAIApiService, SchedaIntense, Attachment, Item, Stop, Word, Ost, Immagine } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ImageModal, ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';

@Component({
  selector: 'app-item-view',
  templateUrl: './item-view.component.html',
})
export class ItemViewComponent implements OnInit {
  isMapVisible: boolean = false;
  isUserLoggedIn = false;
  id: number;
  loading: boolean = true;
  imageUrl: string = "";
  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;

  isSmallScreen: boolean = false;
  immagine: Attachment;
  immagini: Attachment[];
  currentIndex: number = 0;
  maxIndex: number = 0;

  tipologie: Attachment[];

  allegati: Attachment[] = [];
  allegato: Attachment;

  segnalazioneForm: FormGroup;
  segnalazioneValue: string;
  segnalazioneText: string;
  showSegnalazione = true;
  wordsSegnalazione: Word[] = [];
  paramsSubscription: any;
  item: Item;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    private activatedroute: ActivatedRoute,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    const segnalazioneValueCtrl = new FormControl(this.segnalazioneValue, [Validators.required]);
    const segnalazioneTextCtrl = new FormControl(this.segnalazioneText, [Validators.required]);

    this.segnalazioneForm = this.formBuilder.group({
      segnalazioneValue: new FormControl(segnalazioneValueCtrl),
      segnalazioneText: new FormControl(segnalazioneTextCtrl)
    });

    this.segnalazioneForm.controls['segnalazioneText'].patchValue('');
  }

  ngOnInit() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0);

    this.id = this.activatedRoute.snapshot.params.id;
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.id = param['id'];
      if (this.id != null) {
        this.wmaiservice.queryItemById(this.id).subscribe(data => {
          if (data[0] != null) {
            this.item = data[0];
            this.getItemAttachments();
            this.getWordsSegnalazioneIntense();
          }
        });
      }
    });
    this.firstStep = true;
  }

  ngOnDestroy() {
    this.wgisservice.clearSelection();
    this.paramsSubscription.unsubscribe();
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }

  getWordsSegnalazioneIntense() {
    this.wmaiservice.getWordsByLocale(this.translateService.getDefaultLang(), 'segnalazione').subscribe(data => {
      this.wordsSegnalazione = data;
    });
  }

  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.immagine[this.currentIndex];
  }

  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.immagine[this.currentIndex];
  }

  toggleSegnalazione() {
    this.showSegnalazione = !this.showSegnalazione;
  }
  /**
   * attraverso un modal si va a segnalare una segnalazione
   */
  submitSegnalazione() {
    if (this.id == null) return;
    var params = this.segnalazioneForm.value;
    // console.log(params);
    let title: string = this.translateService.instant('modal.segnalazione.title');
    let content: string = this.translateService.instant('modal.segnalazione.confirm');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        if (this.isUserLoggedIn) {
          this.wmaiservice.sendAlertToRas(this.id, 'item', params).subscribe(data => {
            let title: string = this.translateService.instant('modal.segnalazione.title');
            let content: string = this.translateService.instant('modal.segnalazione.success');
            this.modalService
              .open(new SimpleModal(title, content, ModalSize.Tiny))
              .onApprove(() => {
              })
              .onDeny(() => "");
          });
        };
        this.router.navigate(['item/' + this.id]);
        this.showSegnalazione = true;
      })
      .onDeny(() => "");
  }
  /**
   * si richiedono gli oggetti attacati
   */
  getItemAttachments() {
    if (this.id != null) {
      this.wmaiservice.queryItemFilesById(this.id).subscribe(data => {
        let allegati = data;
        allegati.forEach(allegato => {
          if (allegato.resource_mimetype.indexOf("png") == -1 && allegato.resource_mimetype.indexOf("jpg") == -1 && allegato.resource_mimetype.indexOf("jpeg") == -1) {
            this.allegati.push(allegato);
          } else
            this.immagini.push(allegato);
        });
      });
      this.loading = false;
      if (this.immagini.length > 0) {
        this.immagine = this.immagini[0];
        this.currentIndex = 0;
        this.maxIndex = this.immagini.length - 1;
      }
    }
  }

}
